/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Surviving source this source was merged into. Absent when it was never merged.
 * @export
 * @interface SourceMergedIntoSource
 */
export interface SourceMergedIntoSource {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the SourceMergedIntoSource interface.
 */
export function instanceOfSourceMergedIntoSource(value: object): value is SourceMergedIntoSource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SourceMergedIntoSourceFromJSON(json: any): SourceMergedIntoSource {
    return SourceMergedIntoSourceFromJSONTyped(json, false);
}

export function SourceMergedIntoSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceMergedIntoSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SourceMergedIntoSourceToJSON(json: any): SourceMergedIntoSource {
    return SourceMergedIntoSourceToJSONTyped(json, false);
}

export function SourceMergedIntoSourceToJSONTyped(value?: SourceMergedIntoSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

